<template>
    <div>
      <p>Below are competencies you have logged.  You must first save them in order to be assessed by a preceptor</p>
      <p><strong>Please Note:</strong> After saving a competency you will be brought back to this page.  Using the '# to Keep in Log' buttons allow you to keep a competency in this list so you can send another one later (you won't have to go find it in the master list again).</p>
        <b-table show-empty empty-text="You have no competencies to save at this time." striped responsive stacked="md" :items="items" :fields="fields">
          <template v-slot:cell(pivot.attempts)="row">
            {{ row.item.pivot.attempts }}
            <b-button-group class="pl-3">
              <b-button @click="addAttempt(row.item.id)" class="btn btn-primary">
                        <span class="icon icon-plus">
                            1</span>
              </b-button>
              <b-button @click="removeAttempt(row.item.id)" class="btn btn-danger">
                  <span class="icon icon-minus">
                      1</span>
              </b-button>
            </b-button-group>
          </template>
            <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                      <b-button @click="sendPreceptor(row.item.id)" class="btn btn-success">
                        <span class="icon icon-save">
                            Save</span>
                    </b-button>
                    
                </b-button-group>
            </template>
        </b-table>
        <a class="btn btn-danger float-right" href="/competency/clear-all">
            <span class="icon icon-trash">
                Clear All</span>
        </a>
    </div>
</template>

<script>
const items = [];

export default {
  data() {
    return {
      items: items,
      fields: [
        { key: "category", label: "Category" },
        { key: "title", label: "Competency" },
        { key: "standard", label: "Standard" },
        { key: "pivot.attempts", label: "# to Keep in Log", class: "text-nowrap" },
        { key: "actions", label: "Action" }
      ]
    };
  },
  methods: {
    addAttempt(id) {
      axios
        .get("/attempts/add/" + id)
        .then(response => (this.items = response.data))
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },
    removeAttempt(id) {
      axios
        .get("/attempts/remove/" + id)
        .then(response => (this.items = response.data))
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },
    sendPreceptor(id) {
      window.location.href = "/competency/send/" + id;
    },
//      for the student competency table
//     addAttempt(id) {
//         axios.get('/competency/add/' + id)
//             .catch(function (error) {
//                 // handle error
//                 console.log(error);
//             });
//         swal("Good Job!", "You attempted this competency", {
//   buttons: {
//     cancel: "Send later",
//     now: "Send now"
//   },
// }).then(now => {
//   if (now) {
//     window.location.href = ('/competency/send/' + id);
//   }
// });
//     }
  },
  mounted() {
    axios
      .get("/attempts")
      .then(response => (this.items = response.data))
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  }
};
</script>

<!-- table-basic-1.vue -->